const htmlFontSize = 16
const fontSize = 14
const coef = fontSize / 14

export const pxToRem = (size) => `${(size / htmlFontSize) * coef}rem`
